import { CityUtil, McLeodClassicIntegration } from "@mcleod/core";
import { AutogenLayoutLookupInvoice } from "./autogen/AutogenLayoutLookupInvoice";
import { DataDisplayEvent, Label, ClickEvent } from "@mcleod/components";

export class LookupInvoice extends AutogenLayoutLookupInvoice {
    /** This is an event handler for the onDataDisplay event of labelCity*/
    labelCityOnDataDisplay(event: DataDisplayEvent) {
        const row = event.rowData;
        (event.target as Label).text = CityUtil.formatCityStateZip(
            row?.get("customer.city"), row?.get("customer.state_id"), row?.get("customer.zip_code"));
    }

    /** This is an event handler for the onClick event of buttonClassicInvoice. */
    buttonClassicInvoiceOnClick(event: ClickEvent) {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.ar.EntryBilling", 
            this.sourceRenditionInvoice.activeRow.get("id"));
    }

    /** This is an event handler for the onClick event of buttonClassicCustomer. */
    buttonClassicCustomerOnClick(event: ClickEvent) {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.ar.EntryCustomer", 
            this.sourceRenditionInvoice.activeRow.get("customer.id"));
    }
}
